import { Component } from '@angular/core';
import { UITheme } from '../../../../../shared/definitions/ui-theme.enum';

@Component({
  selector: 'two-panel-layout',
  standalone: false,
  templateUrl: './two-panel-layout.component.html',
  styleUrls: ['./two-panel-layout.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class TwoPanelLayoutComponent {
  uiTheme = UITheme;
}
